/* leverege-molten no-export */
import { Plugins, Match } from '@leverege/plugin';
import DefaultTriggerHandler from "./DefaultTriggerHandler.js";
function createMatch(objectType, path, client, dataViewerType) {
  return {
    objectType,
    path,
    client,
    dataViewerType
  };
}
export function getQueryTriggers({
  objectType,
  path,
  client,
  dataViewerType,
  relationship,
  caches
}) {
  return caches.calc('queryPlugins', () => {
    const matches = createMatch(objectType, path, client, dataViewerType);
    const v = Plugins.createView('QueryTriggerHandler', {
      name: `${client}.${path}`,
      filter: plg => {
        const isMatch = Match.isMatch(matches, plg.matches);
        return isMatch;
      }
    });
    return v.get();
  }, objectType, path, client, dataViewerType, relationship, Plugins.getVersion('QueryTriggerHandler'));
}
export function getQueryTrigger(opts, cxt) {
  const handlers = getQueryTriggers(opts);
  const Handler = handlers.sort(numSortComparator)[0]?.handler;
  if (Handler) {
    return new Handler(opts, cxt);
  }
  return new DefaultTriggerHandler(opts, cxt);
}
function numSortComparator(a, b) {
  const an = a.sort || 0;
  const bn = b.sort || 0;
  return an - bn;
}